<template>
  <div class="surface-50 py-5">
    <div class="surface-0 px-4 border-1 border-200 py-8 md:px-6 lg:px-8 md:mx-5 xl:mx-8">
      <div
        v-if="hasAuthors || eventDate"
        class="text-600 text-sm mb-3 flex flex-wrap align-items-center gap-2"
      >
        <div v-if="hasAuthors" class="font-bold inline-flex">
          <Authors
            :where="{
              id: item?.person_id ? { $eq: item.person_id } : { $in: item.authors },
            }"
          />
        </div>
        <div v-if="eventDate" class="flex align-items-center gap-2">
          <i
            v-if="hasAuthors"
            class="pi pi-circle-fill green"
            style="font-size: 0.5rem"
            aria-hidden="true"
          />
          <time :datetime="eventDate" class="text-500">
            {{ eventDate }}
          </time>
        </div>
      </div>
      <div
        v-if="item.name"
        class="border-purple-800 font-medium text-2xl p-3 mb-3 text-900"
        style="border-left: 8px solid"
      >
        {{ item?.name }}
      </div>
      <DeferredContent v-if="item?.img">
        <img
          :src="getImgPath(item.img)"
          :alt="item.name || ''"
          class="block h-auto md:h-40rem w-full"
          style="object-fit: contain"
        />
      </DeferredContent>
      <div v-if="item?.body" v-html="item.body" class="line-height-3 text-sm text-800 mb-3"></div>
      <Navigation />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})
const hasAuthors = computed(() => Boolean(props.item?.person_id || props.item?.authors?.length))
const eventDate = computed(() => props.item?.date)

const getImgPath = (uuid) => {
  return uuid ? `/media/${uuid}.webp` : '/images/heading_image2.webp'
}
</script>
